import { render, staticRenderFns } from "./15-member-profile-extras.vue?vue&type=template&id=63a3f876&scoped=true"
import script from "./15-member-profile-extras.vue?vue&type=script&lang=js"
export * from "./15-member-profile-extras.vue?vue&type=script&lang=js"
import style0 from "./15-member-profile-extras.vue?vue&type=style&index=0&id=63a3f876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a3f876",
  null
  
)

export default component.exports